import { EnvioService } from '../services/envio.service';
import { ClienteService } from '../services/cliente.service';
import { ListadoEnvios } from '../models/viewmodels/listadoEnvios';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { ReenvioComprobanteViewModel } from '../models/viewmodels/ReenvioComprobanteViewModel';
var EnviosComponent = /** @class */ (function () {
    function EnviosComponent(envioService, router, clienteService) {
        this.envioService = envioService;
        this.router = router;
        this.clienteService = clienteService;
        this.query = new FormControl();
        this.pagina = 0;
        this.cantidadPorPagina = 20;
        this.listado = null;
        this.paginas = 0;
        this.isLoading = true;
        this.display = false;
        this.mostrarDetalle = false;
        this.tags = [];
        this.clientes = [];
        this.reenviarTodos = false;
        this.mostrarReenvioComp = false;
        this.alert = {
            tipo: "success",
            titulo: "",
            mensaje: "",
            visible: false
        };
        this.listado = new ListadoEnvios();
        this.reenvioComprobantes = new ReenvioComprobanteViewModel();
        this.reenvioComprobantes.todos = true;
        this.listado.envios = new Array();
        this.es = {
            firstDayOfWeek: 1,
            dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
            dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
            dayNamesMin: ["D", "L", "M", "X", "J", "V", "S"],
            monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
            monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
            today: 'Hoy',
            clear: 'Borrar'
        };
    }
    EnviosComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.obtenerEnvios();
        this.query.valueChanges
            .debounceTime(400)
            .distinctUntilChanged()
            .subscribe(function (term) {
            if (term.length == 0) {
                _this.pagina = 0;
                _this.obtenerEnvios();
            }
            else if (term.length > 2) {
                _this.obtenerEnvios();
            }
        });
    };
    EnviosComponent.prototype.obtenerEnvios = function (paginaActual) {
        var _this = this;
        this.pagina = paginaActual == null ? 0 : paginaActual;
        this.spinner.isRunning = true;
        this.envioService.listado(this.pagina, this.cantidadPorPagina, this.query.value ? this.query.value : "").subscribe(function (result) {
            _this.spinner.isRunning = false;
            _this.listado = result;
            if (_this.listado && _this.listado.total > 0) {
                _this.paginas = Math.floor((_this.listado.total + _this.cantidadPorPagina - 1) / _this.cantidadPorPagina);
            }
        });
    };
    EnviosComponent.prototype.anterior = function () {
        this.obtenerEnvios(this.pagina - 1);
    };
    EnviosComponent.prototype.siguiente = function () {
        this.obtenerEnvios(this.pagina + 1);
    };
    EnviosComponent.prototype.buscar = function () {
        this.pagina = 0;
        this.obtenerEnvios();
    };
    EnviosComponent.prototype.showDialog = function (envio) {
        this.envio = envio;
        this.display = true;
    };
    EnviosComponent.prototype.eliminar = function () {
        var _this = this;
        this.display = false;
        this.spinner.isRunning = true;
        this.envioService.eliminar(this.envio.id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar envio";
            if (result.status == 204) {
                _this.alert.tipo = "success";
                _this.alert.mensaje = "El envio se ha eliminado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "El envio no se ha podido eliminar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.listado.envios = _this.listado.envios.filter(function (u) {
                return u.id != _this.envio.id;
            });
            _this.envio = null;
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Eliminar envio";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "El envio no se ha podido eliminar. Por favor vuelva a intentarlo.";
        });
    };
    EnviosComponent.prototype.reenviar = function (id) {
        var _this = this;
        this.spinner.isRunning = true;
        this.envioService.reenviar(id).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar comprobantes";
            if (result.status == 200) {
                _this.obtenerEnvios();
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Los comprobantes seleccionados se ha reenviado correctamente";
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los comprobantes seleccionados no se han podido reenviar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar comprobantes";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los comprobantes seleccionados no se han podido reenviar. Por favor vuelva a intentarlo.";
        });
    };
    EnviosComponent.prototype.reenviarComprobantes = function () {
        var _this = this;
        this.spinner.isRunning = true;
        this.envioService.reenviarComprobantes(this.reenvioComprobantes).subscribe(function (result) {
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar comprobantes";
            if (result.status == 201) {
                _this.obtenerEnvios();
                _this.alert.tipo = "success";
                _this.alert.mensaje = "Los comprobantes se ha reenviado correctamente";
                _this.mostrarReenvioComp = false;
                _this.reenvioComprobantes = new ReenvioComprobanteViewModel();
                _this.obtenerEnvios();
            }
            else {
                _this.alert.tipo = "danger";
                _this.alert.mensaje = "Los comprobantes no se han podido reenviar. Por favor vuelva a intentarlo.";
            }
            _this.alertComponent.setType(_this.alert.tipo);
            _this.spinner.isRunning = false;
        }, function (error) {
            _this.spinner.isRunning = false;
            _this.alert.visible = true;
            _this.alert.titulo = "Reenviar comprobantes";
            _this.alert.tipo = "danger";
            _this.alertComponent.setType(_this.alert.tipo);
            _this.alert.mensaje = "Los comprobantes no se han podido reenviar. Por favor vuelva a intentarlo.";
        });
    };
    EnviosComponent.prototype.verDetalle = function (envio) {
        this.mostrarDetalle = true;
        this.envio = envio;
    };
    EnviosComponent.prototype.estado = function (id) {
        var estado = "";
        switch (id) {
            case 0:
                estado = "Generado";
                break;
            case 1:
                estado = "Enviado";
                break;
            case 2:
                estado = "No Enviado";
                break;
            case 3:
                estado = "Recibido";
                break;
            case 4:
                estado = "Spam";
                break;
            case 5:
                estado = "Abierto";
                break;
            case 6:
                estado = "Rebotado";
                break;
            case 7:
                estado = "Rechazado";
                break;
        }
        return estado;
    };
    EnviosComponent.prototype.paginate = function (event) {
        //event.first = Index of the first record
        //event.rows = Number of rows to display in new page
        //event.page = Index of the new page
        //event.pageCount = Total number of pages
        this.obtenerEnvios(event.page);
    };
    EnviosComponent.prototype.filtrar = function (event) {
        var _this = this;
        if (event.query.length > 3) {
            return this.clienteService.listado(0, 10, event.query).subscribe(function (response) {
                _this.clientes = response.clientes;
            });
        }
    };
    EnviosComponent.ctorParameters = function () { return [{ type: EnvioService }, { type: Router }, { type: ClienteService }]; };
    return EnviosComponent;
}());
export { EnviosComponent };
//# sourceMappingURL=envios.component.js.map


// WEBPACK FOOTER //
// envios.component.js